import { AbstractControl, ValidatorFn } from "@angular/forms";

export function ValidateValueInString(val : string, init: number, end : number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        let value : string = control.value;
       
        if(value?.substring(init, end+1) != val){
            return { 'invalidChar': true }
        }

        return null;
    }
    
}

export function ValidateTwoValueInString(valOne : string, valTwo : string,init: number, end : number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        let value : string = control.value;
       
        if(value?.substring(init, end+1) != valOne && value?.substring(init, end+1) != valTwo){
            return { 'invalidChar': true }
        }

        return null;
    }
    
    
}

/** Transferência: adquirente aceita miolo .00 ou .10. Miolo .40 é institucional e não é aceito. */
export function ValidateTransferRegistradorAccount(init: number, end: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const value: string = control.value;

        if (!value) {
            return null;
        }

        const miolo = value.substring(init, end + 1);

        if (miolo === '40') {
            return { institutionalAccountNotAllowed: true };
        }

        if (miolo !== '00' && miolo !== '10') {
            return { invalidChar: true };
        }

        return null;
    };
}